const $ = jQuery.noConflict();

class Tabs {
    constructor() {}
    init() {
        $(document).on('click', '.tabs-dropdown__tab', function() {
            const section = $( this ).closest('section');
            section.find('.tabs-dropdown__list').toggleClass('expanded');

            section.find('.tabs-dropdown__tab').removeClass('active');
            $(this).addClass('active');

            // Set tab content active
            var tab_id = $( this ).attr('data-tab');
            section.find('.tab-content').removeClass('active');
            $( this ).addClass('active');
            $( '#' + tab_id ).addClass('active');
        });

        $(document).on('click', '.tabs-dropdown__arrows > button', function() {
            const section    = $( this ).closest('section');
            const isNext     = $( this ).hasClass('tabs-dropdown__arrow-next')
            const currentTab = section.find( '.tabs-dropdown__tab.active' );
            
            let targetTab;
            if ( isNext ) {
                const nextTab = currentTab.next();
                if ( nextTab.length ) {
                    targetTab = nextTab
                } else {
                    targetTab = currentTab.parent().find(':first-child')
                }
            } else {
                const prevTab = currentTab.prev();
                if ( prevTab.length ) {
                    targetTab = prevTab
                } else {
                    targetTab = currentTab.parent().find(':last-child')
                }
            }

            targetTab.trigger('click')
        });
    }
}

export default new Tabs();
